import { render, staticRenderFns } from "./DeliveryStatistics.vue?vue&type=template&id=afa6e71e&"
import script from "./DeliveryStatistics.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports